import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { TenantListItem } from "../../../models/users";

interface DeleteTenantDialogProps {
  visible: boolean;
  onHide: () => void;
  tenant: TenantListItem | undefined;
  onDelete: (id: string) => void;
  loading: boolean;
}

export const DeleteTenantDialog: React.FC<DeleteTenantDialogProps> = ({
  visible,
  onHide,
  tenant,
  onDelete,
  loading,
}) => {
  if (!tenant) return null;

  return (
    <Dialog
      header="Eliminar tenant"
      visible={visible}
      style={{ width: "50vw" }}
      onHide={onHide}
      footer={
        <div>
          <Button
            severity="danger"
            label="Eliminar"
            onClick={() => onDelete(tenant.id)}
            loading={loading}
          />
          <Button
            severity="secondary"
            label="Cancelar"
            onClick={onHide}
          />
        </div>
      }
    >
      <h1 className="text-3xl text-red-500 m-0 p-0">
        <i className="pi pi-exclamation-triangle"></i> ¡Cuidado!
      </h1>
      <p className="m-0 p-0">
        ¿Estás seguro que deseas eliminar el tenant{" "}
        <b>{tenant.provider}</b>?
      </p>
      {tenant.userCount > 0 && (
        <p className="text-orange-600 mt-2">
          <i className="pi pi-info-circle"></i> Este tenant tiene{" "}
          <b>{tenant.userCount}</b> usuarios asignados.
        </p>
      )}
    </Dialog>
  );
}; 